import React, { useState, useEffect } from 'react';
import FilterBar from './FilterBar';
import ArticleList from './ArticleList';
import '../css/style.css'; 
import { fetchReviews } from '../api/reviewAPI'; 
import { Link } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const MainPage = () => {
  const { user } = useUser();
  const [filters, setFilters] = useState({
    companyName: '',
    role: '',
    location: '',
  });
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadReviews = async () => {
      setLoading(true);
      setError('');
      try {
        const queryParams = new URLSearchParams();

        if (filters.companyName) queryParams.append('companyName', filters.companyName);
        if (filters.role) queryParams.append('role', filters.role);
        if (filters.location) queryParams.append('location', filters.location);

        const data = await fetchReviews(queryParams.toString());
        setArticles(data);
      } catch (error) {
        console.error('Failed to fetch reviews:', error);
        setError('Unable to load interviews right now. Please refresh and try again.');
      } finally {
        setLoading(false);
      }
    };

    loadReviews();
  }, [filters]);

  const activeFiltersCount = Object.values(filters).filter(Boolean).length;
  const totalCompanies = new Set(articles.map((article) => article.companyName)).size;
  const totalRoles = new Set(articles.map((article) => article.role)).size;

  return (
    <main className="main-page">
      <section className="hero-section">
        <div className="hero-copy">
          <span className="hero-eyebrow">Real interview experiences, minus the noise</span>
          <h1>Interview prep built from actual candidate stories.</h1>
          <p>
            Search company-specific interview writeups, compare roles and locations,
            and publish your own experience for the next candidate behind you.
          </p>
          <div className="hero-actions">
            <a className="primary-cta" href="#interview-feed">Explore interviews</a>
            {user && (
              <Link className="secondary-cta" to="/add-article">
                Share your interview
              </Link>
            )}
          </div>
        </div>
        <div className="hero-summary">
          <div className="summary-card">
            <span className="summary-label">Interviews available</span>
            <strong>{loading ? '...' : articles.length}</strong>
          </div>
          <div className="summary-card">
            <span className="summary-label">Companies covered</span>
            <strong>{loading ? '...' : totalCompanies}</strong>
          </div>
          <div className="summary-card">
            <span className="summary-label">Roles covered</span>
            <strong>{loading ? '...' : totalRoles}</strong>
          </div>
        </div>
      </section>

      <section id="interview-feed" className="feed-shell">
        <FilterBar
          filters={filters}
          activeFiltersCount={activeFiltersCount}
          onSearch={(filterValues) => setFilters(filterValues)}
        />
        <ArticleList
          articles={articles}
          loading={loading}
          error={error}
          onRetry={() => setFilters((currentFilters) => ({ ...currentFilters }))}
        />
      </section>
    </main>
  );
};

export default MainPage;
